import { render } from "./verify.vue?vue&type=template&id=a71e8ce0"
import script from "./verify.vue?vue&type=script&lang=js"
export * from "./verify.vue?vue&type=script&lang=js"

import "./verify.vue?vue&type=style&index=0&id=a71e8ce0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__